
import { PlatformData } from './platform-data';

export class TransactionTypeDetector {
  static determineTransactionType(
    platform: string,
    isPrivateSeller: boolean,
    merchantName: string
  ): 'B2C' | 'C2C' | 'subscription' | 'gig_platform' | 'event_ticketing' | 'accommodation' {
    // Check for subscription platforms first
    const subscriptionPlatforms = [
      'apple_app_store', 'google_play', 'netflix', 'spotify', 'youtube_premium',
      'adobe_creative_cloud', 'canva_pro', 'notion', 'grammarly', 'squarespace',
      'nordvpn', 'expressvpn'
    ];
    
    if (subscriptionPlatforms.includes(platform)) {
      return 'subscription';
    }

    // Check for event/ticketing platforms
    const eventTicketingPlatforms = [
      'ticketmaster', 'stubhub', 'eventbrite', 'seatgeek'
    ];
    
    if (eventTicketingPlatforms.includes(platform)) {
      return 'event_ticketing';
    }

    // Check for accommodation platforms
    const accommodationPlatforms = [
      'airbnb', 'booking'
    ];
    
    if (accommodationPlatforms.includes(platform)) {
      return 'accommodation';
    }

    // Check for gig/freelance platforms
    const gigPlatforms = [
      'upwork', 'fiverr', 'freelancer', 'peopleperhour', 'taskrabbit'
    ];
    
    if (gigPlatforms.includes(platform)) {
      return 'gig_platform';
    }

    // First check if this is a known B2C retailer
    if (PlatformData.isB2CRetailer(merchantName)) {
      return 'B2C';
    }

    // C2C platforms are always C2C unless it's a major B2C retailer
    const c2cPlatforms = [
      'facebook_marketplace', 'offerup', 'craigslist', 'mercari', 'poshmark', 
      'depop', 'nextdoor', 'varagesale', 'vinted', 'reverb', 'kidizen', 
      'tradesy', 'chairish', 'fivemiles', 'gunbroker'
    ];
    
    if (c2cPlatforms.includes(platform)) {
      return 'C2C';
    }

    // Platform-specific logic for mixed platforms
    switch (platform) {
      case 'amazon':
        return isPrivateSeller ? 'C2C' : 'B2C';
      
      case 'ebay':
        // eBay is primarily C2C unless it's a clear business or major retailer
        return /store|business|company|inc|ltd|llc/i.test(merchantName) && !isPrivateSeller ? 'B2C' : 'C2C';
      
      case 'etsy':
        return 'C2C'; // Etsy is primarily individual creators
      
      case 'shopify':
        return 'B2C'; // Shopify stores are typically businesses
      
      case 'paypal':
        return isPrivateSeller ? 'C2C' : 'B2C';
      
      default:
        // General business indicators
        const businessIndicators = /store|shop|company|inc|ltd|llc|corp|business|enterprise/i;
        return businessIndicators.test(merchantName) && !isPrivateSeller ? 'B2C' : 'C2C';
    }
  }
}
